<template>
    <section class="d-flex">
        <b-form-group style="width: 100%;">
            <div style="border-radius: 4px;" v-bind:class="isFocus ? invalidForm ? 'fail-focus' : 'accept-focus' : invalidForm ? 'fail' : 'accept'">
                <b-input-group>
                    <b-form-input
						name="searchString"
                        class="without-border"
                        v-model="searchString"
                        list="options"
                        placeholder="Escreve e seleciona uma opção"
                        @input="find"
                        v-validate="{ required: validate, matchRecordId:optionSelected }"
                        :state="validateState('searchString')"
                        autocomplete="off"
                        @focus="() => isFocus = true"
                        @blur="() => isFocus = false"
                    />
					<b-input-group-append>
						<b-button
							class="btn-select"
							@click="showAllOptions(true)"
						>
							{{ showArrowBtn }}
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</div>
            <section v-if="visibleSuggestion" id="options" class="detalist">
                <div
                    class="detalist-option"
                    v-bind:class="option.value ? isMobile ? 'detalist-option-mobile' : '' : 'detalist-option-add'"
                    v-for="option in showOptions" :key="option.value"
                    @click="changeSelect(option)"
                >
                    {{ option.text }}
                </div>
            </section>
        </b-form-group>
    </section>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { removeAccents } from "@/helpers/common";

	export default {
		components: {

		},

		name: "SearchSelect",
		props: {
			name: {
				type: String,
				required: true
			},
			options: {
				type: Array,
				required: true
			},
			visibleSuggestion: {
				type: Boolean,
				required: false,
				default: false
			},
			isMobile: {
				type: Boolean,
				required: false
			},
			newRecord: {
				type: Object,
				required: false,
				default: () => {}
			},
			clearSelect: {
				type: Boolean,
				required: false
			},
			validate: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data () {
			return {
				searchString: "",
				showOptions: [],
				showArrowBtn: "▼",
				invalidForm: null,
				optionSelected: {},
				isFocus: false,
				isClicked: false
			};
		},

		watch: {
			visibleSuggestion () {
				this.handleShowOptions();
			},
			newRecord () {
				this.setNewRecord();
			},
			clearSelect () {
				this.searchString = "";
				this.optionSelected.value = null;
				this.optionSelected.text = null;
			},
			invalidForm () {
				this.$emit("invalidSearch", { invalidSearch: this.invalidForm, fatherComponent: this.name });
			}
		},

		computed: {
			rulesValidate () {
				return this.validate ? "required|" : "";
			}
		},

		mounted () {
			if (this.newRecord.id) {
				this.setNewRecord();
			}
		},

		methods: {
			async find () {
				this.isClicked = false;
				this.optionSelected.value = null;
				this.optionSelected.text = null;

				this.showOptions = await this.options.reduce((acc, item) => {
					if (removeAccents(item.text).toLowerCase().includes(removeAccents(this.searchString).toLowerCase())) {
						acc.push({
							text: item.text,
							value: item.value
						});

					}

					return acc;
				}, []);
				if (this.searchString && !this.showOptions.length) {
					this.showOptions.push({ text: "Não encontrado, clique para adicionar", value: null });
				}

				if (this.showOptions.length && this.searchString) {
					const handleSuggestion = { visibleSuggestion: true, name: this.name };
					this.$emit("handleSuggestion", handleSuggestion);
				}
			},

			showAllOptions (isClicked) {
				this.isClicked = isClicked;
				if (!this.optionSelected.value) {
					this.searchString = "";
				}

				const handleSuggestion = { visibleSuggestion: !this.visibleSuggestion, name: this.name };
				this.$emit("handleSuggestion", handleSuggestion);
			},

			handleShowOptions () {
				this.showArrowBtn = this.visibleSuggestion ? "▲" : "▼";

				if (this.isClicked) {
					this.showOptions = this.options.reduce((acc, item) => {
						acc.push({
							text: item.text,
							value: item.value
						});

						return acc;
					}, []);
				}

				this.isClicked = false;
			},

			changeSelect (option) {
				this.optionSelected = { ...option };
				if (!this.optionSelected.value) {
					this.optionSelected.text = this.searchString;
				}
				this.searchString = this.optionSelected.text;
				this.$emit("changeSelect", { ...this.optionSelected, fatherComponent: this.name });
				this.showAllOptions();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			async setNewRecord () {
				if (this.newRecord.notPermited) {
					await this.$swal({
						title: "Registro Inválido",
						text: "O Registro criado não permite esta ação!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					this.searchString = "";
					this.optionSelected.value = null;
					this.optionSelected.text = "";
					return;
				}
				this.searchString = this.newRecord.description;
				this.optionSelected.value = this.newRecord.id;
				this.optionSelected.text = this.newRecord.description;
				this.$emit("changeSelect", { ...this.optionSelected, fatherComponent: this.name });
			}
		}
	};
</script>

<style scoped>
    .fail {
        border: 1px solid #dc3545;
    }

    .fail-focus {
        border: 1px solid #dc3545 !important;
        box-shadow: 0 0 0 3px #dc354533 !important;
    }

    .accept {
        border: 1px solid #28a745;
    }

    .accept-focus {
        border: 1px solid #28a745;
        box-shadow: 0 0 0 3px #28a74533;
    }

    .without-border {
        border: none !important;
    }

    .without-border:focus {
        border: none;
        outline: none;
        box-shadow: none;
    }

    .btn-select {
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: white !important;
        color: grey !important;
        border: none;

    }

    .btn-select:focus, .btn-select:active {
        outline: none !important;
        box-shadow: none !important;
    }

</style>